import React, { useEffect, useState } from 'react';
import { Message, Segment } from 'semantic-ui-react';
import { cqvRequestService, CqvRequestMetricsDto } from '../../services/contracts/CqvRequestService';
import { CQV_VTME_THEME, cqvVtmeKpiCardLabelStyle, cqvVtmeQueueCardStyle, cqvVtmeSegmentStyle } from './cqvVtmePageTheme';

const KpiCard: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <Segment style={cqvVtmeQueueCardStyle}>
    <div style={{ fontSize: 28, fontWeight: 800, lineHeight: 1, color: CQV_VTME_THEME.accentLilac }}>{value}</div>
    <div style={cqvVtmeKpiCardLabelStyle}>{label}</div>
  </Segment>
);

const formatMinutes = (minutes?: number | null): string => {
  if (minutes === null || minutes === undefined) return '—';
  if (minutes < 60) return `${Math.round(minutes)}min`;
  const hours = Math.floor(minutes / 60);
  const rest = Math.round(minutes % 60);
  return `${hours}h${rest > 0 ? ` ${rest}min` : ''}`;
};

/**
 * AC#7 — solicitacao-cqv-automatica-sla: tempo entre "solicitado" e "Aprovado CQV",
 * e casos de estouro de SLA, como bloco a mais na página de orquestração VTME (não
 * mexe no CqvVtmeAssignmentReportDto grande — endpoint próprio, ver plan.md).
 */
const CqvRequestMetricsPanel: React.FC = () => {
  const [metrics, setMetrics] = useState<CqvRequestMetricsDto | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    cqvRequestService
      .getMetrics()
      .then((data) => {
        if (!cancelled) setMetrics(data);
      })
      .catch((err) => {
        console.error('Erro ao carregar métricas de Solicitação de CQV:', err);
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (error) {
    return (
      <Segment style={cqvVtmeSegmentStyle}>
        <Message error>Não foi possível carregar as métricas de Solicitação de CQV.</Message>
      </Segment>
    );
  }

  if (!metrics) return null;

  return (
    <Segment style={cqvVtmeSegmentStyle}>
      <h4 style={{ color: CQV_VTME_THEME.text, marginBottom: 12 }}>Solicitação de CQV (botão → WhatsApp)</h4>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 12 }}>
        <KpiCard label="Solicitados" value={metrics.totalRequests} />
        <KpiCard label="Pendentes" value={metrics.pending} />
        <KpiCard label="Aprovados no prazo" value={metrics.approvedOnTime} />
        <KpiCard label="Recusados" value={metrics.rejectedManual + metrics.rejectedViaWhatsAppReply} />
        <KpiCard label="Estouros de SLA" value={metrics.slaOverdueAlertsSent} />
        <KpiCard label="Tempo médio até aprovação" value={formatMinutes(metrics.averageMinutesToApproval)} />
      </div>
      {metrics.rejectedViaWhatsAppReply > 0 ? (
        <div style={{ fontSize: 12, color: CQV_VTME_THEME.muted, marginTop: 10 }}>
          {metrics.rejectedViaWhatsAppReply} recusa(s) via resposta direta no grupo do WhatsApp.
        </div>
      ) : null}
    </Segment>
  );
};

export default CqvRequestMetricsPanel;
